module.exports = __webpack_public_path__ + "static/media/icons-arrows-buttons-left-arrow-dark-gray.462bedd3.svg";